// const BASE_URL ='http://localhost:8080'
const BASE_URL = 'https://gluconutris-questionnaire.herokuapp.com'

export const API_URL = (slug) => `${BASE_URL}/${slug}`